import { ajaxFunc } from '../tools';
const shareGoods = {
  /****分享商品的接口****/

  //分享商品- 获取列表
  hotGoods_list: ajaxFunc('/goods/get_agent_share_goods_list', 'get'),
  // 加入购物车接口
  add_list:ajaxFunc('/cart/agent_share_goods_add_cart', 'post'),
  //发现分享
  find_list:ajaxFunc('/find/info', 'post'),
};

export default shareGoods;



// WEBPACK FOOTER //
// ./src/request/api/shareGoods.js